import einsteinutils from './einsteinutils';
import api from './api';
import axios from 'axios';
export const COLOUR_ATTRIBUTE = 'color';
export const SIZE_ATTRIBUTE = 'size';
export const getVariationValues = (product, attributeId) => {
    var _a, _b;
    return (((_b = (_a = product === null || product === void 0 ? void 0 : product.variationAttributes) === null || _a === void 0 ? void 0 : _a.find((variation) => {
        return variation.attributeId === attributeId;
    })) === null || _b === void 0 ? void 0 : _b.values) || []);
};
export const getColorVariations = (product) => {
    return getVariationValues(product, COLOUR_ATTRIBUTE);
};
export const getSizeVariations = (product) => {
    return getVariationValues(product, SIZE_ATTRIBUTE);
};
export const getColorVariationActive = (product) => {
    return getColorVariations(product).find(({ selected }) => selected).value;
};
export const getProductMasterId = (product) => {
    if (product.masterId == product.id) {
        const colorActiveId = getColorVariationActive(product);
        return product.masterId.replace(colorActiveId, '');
    }
    else {
        return product.masterId;
    }
};
export const getProductAvailability = (product) => {
    let productAvailability;
    if (product === null || product === void 0 ? void 0 : product.availability) {
        if (product.availability.inStockDate) {
            productAvailability = 'https://schema.org/InStock';
        }
        else if (product.availability.lowStock) {
            productAvailability = 'https://schema.org/LimitedAvailability';
        }
        else if (product.availability.preorder) {
            productAvailability = 'https://schema.org/PreOrder';
        }
        else {
            //also if current.availability.isOutOfStock
            productAvailability = 'https://schema.org/OutOfStock';
        }
    }
    return productAvailability;
};
export const getSizeAvailability = (product, isPreorder) => {
    let productAvailability;
    if (isPreorder) {
        productAvailability = 'https://schema.org/PreOrder';
    }
    else if ((product === null || product === void 0 ? void 0 : product.ATS) <= 0) {
        productAvailability = 'https://schema.org/OutOfStock';
    }
    else if ((product === null || product === void 0 ? void 0 : product.ATS) === 1) {
        productAvailability = 'https://schema.org/LimitedAvailability';
    }
    else {
        productAvailability = 'https://schema.org/InStock';
    }
    return productAvailability;
};
export const getSimilarProducts = (product) => {
    return new Promise((resolve, reject) => {
        // const testProduct = {} as any;
        // testProduct.hasLimitedAvailability = true;
        // testProduct.uuid = 'testproduct';
        // testProduct.limitedAvailabilityConfig = {
        //   showLimitedAvailabilityLabel: true,
        //   showSimilarProducts: true,
        //   similarProductConfig: {
        //     useRecommender: false,
        //     recommenderId: 'PDP_Recently-Viewed',
        //     // productIdList: ['G20918C00033829H8999', 'G20911A0016868950455'],
        //     productIdList: ['G20918C00033829H8999', 'G20911A0016868950455', '569100002A01PR001000100F', 'G10911A109005327977600', '569100001A05PR001000', 'H209Z1A00002M2904999'],
        //   },
        // };
        // const thisProduct = testProduct;
        var _a, _b;
        const thisProduct = product;
        // Check if similar products for given product are already in session
        const similarProductsSession = sessionStorage.getItem('similar' + thisProduct.uuid + window.locale);
        if (similarProductsSession) {
            const similarProductsSessionJSON = JSON.parse(similarProductsSession);
            resolve(similarProductsSessionJSON);
            return;
        }
        // Fetch from einstein or fetch tiles from static list;
        if ((_a = thisProduct.limitedAvailabilityConfig) === null || _a === void 0 ? void 0 : _a.showSimilarProducts) {
            const similarProductConfig = thisProduct.limitedAvailabilityConfig.similarProductConfig;
            if ((_b = similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.productIdList) === null || _b === void 0 ? void 0 : _b.length) {
                api.getProductTiles(similarProductConfig.productIdList).then((data) => {
                    if (data) {
                        const availableProducts = data.filter((p) => { var _a; return ((_a = p.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock) !== true && !p.isBoutiqueExclusive; });
                        sessionStorage.setItem('similar' + thisProduct.uuid, JSON.stringify(availableProducts));
                        resolve(availableProducts);
                    }
                    else {
                        reject();
                    }
                });
            }
            else if (similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.useRecommender) {
                const cancelTokenSource = axios.CancelToken.source();
                const anchors = [{ masterId: thisProduct.masterId, id: thisProduct.id }];
                einsteinutils.productRecommendations(similarProductConfig.recommenderId, (rec) => {
                    if (rec && rec.products && rec.products.length > 0) {
                        sessionStorage.setItem('similar' + thisProduct.uuid, JSON.stringify(rec.products));
                        resolve(rec.products);
                    }
                    else {
                        reject();
                    }
                }, cancelTokenSource, anchors);
            }
            else {
                reject();
            }
        }
    });
};
